export interface ISchedulerConfigModel {
  isFeatureEnabled(key: string): boolean;
  getConfigProperty(key: string): string;
}
export class SchedulerConfigModel {
  constructor(private appConfigModel: any) {}
  isFeatureEnabled(key: any) {
    return this.appConfigModel ? this.appConfigModel.isFeatureEnabled(key) : true;
  }
  getConfigProperty(key: any) {
    return this.appConfigModel ? this.appConfigModel.getConfigProperty(key) : '';
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/config/models/scheduler_config_model.ts